import { Link, useLocation } from 'react-router';

import { useStrings } from '../hooks/useStrings';

// Routes that render inside <AppShell> (see app.tsx). The shell adds a fixed
// bottom nav (~5rem tall, z-20); the tag has to sit above it on those pages
// or it would overlap the rightmost nav button. Keep this in sync with the
// AppShell route group in app.tsx.
const APP_SHELL_PREFIXES = [
  '/onboarding/chat',
  '/dashboard',
  '/workout',
  '/afterglow',
  '/journal',
  '/mood-history',
  '/profile',
];

export function VersionTag() {
  const { pathname } = useLocation();
  const { strings } = useStrings();

  const sha = import.meta.env.VITE_BUILD_SHA;
  const label = sha ? sha.slice(0, 7) : strings.versionTag.devFallback;
  const inAppShell = APP_SHELL_PREFIXES.some((p) => pathname.startsWith(p));

  return (
    <Link
      to="/profile"
      className="fixed right-2 z-30 text-[10px] uppercase tracking-[0.15em] text-muted-foreground/60 hover:text-muted-foreground"
      style={{
        bottom: inAppShell
          ? 'calc(env(safe-area-inset-bottom) + 4.75rem)'
          : 'max(env(safe-area-inset-bottom), 0.25rem)',
      }}
    >
      {strings.versionTag.prefix} {label}
    </Link>
  );
}
